/* BANNANNA collection — Load More (progressive enhancement).
   The button works as a plain next-page link without JS.
   With JS, intercepts the click, fetches the next page, parses out the
   product grid and the next Load More URL, then appends cards inline. */

(function () {
  function init(scope) {
    var root = scope || document;
    var btn = root.querySelector('[data-load-more]');
    var grid = root.querySelector('[data-product-container]');
    if (!btn || !grid || btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';

    btn.addEventListener('click', function (event) {
      // Allow modifier-clicks to fall back to native navigation.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      loadNext(btn, grid);
    });
  }

  function loadNext(btn, grid) {
    var url = btn.getAttribute('href');
    if (!url || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');

    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var nextGrid = doc.querySelector('[data-product-container]');
        var nextBtn = doc.querySelector('[data-load-more]');

        if (nextGrid) {
          var fragment = document.createDocumentFragment();
          var nodes = Array.from(nextGrid.children);
          nodes.forEach(function (node) { fragment.appendChild(node); });
          grid.appendChild(fragment);
        }

        if (nextBtn) {
          btn.setAttribute('href', nextBtn.getAttribute('href'));
          var nextCount = nextBtn.querySelector('[data-load-more-count]');
          var thisCount = btn.querySelector('[data-load-more-count]');
          if (nextCount && thisCount) thisCount.textContent = nextCount.textContent;
          btn.removeAttribute('aria-busy');
        } else {
          // No more pages — remove the button entirely.
          var wrap = btn.closest('[data-load-more-wrap]') || btn;
          wrap.parentNode.removeChild(wrap);
        }
      })
      .catch(function () {
        // On any failure, fall back to navigation.
        window.location.href = url;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init on Shopify theme-editor section reload.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
